import { Backdrop } from '@mui/material';
import {
  MeetingStatus,
  useMeetingEvent,
  useMeetingManager,
  useMeetingStatus,
} from 'amazon-chime-sdk-component-library-react';
import { EventName } from 'amazon-chime-sdk-js';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import {
  MeetingPage,
  useMeetingContext,
} from '../../contexts/meeting/meetingContext';
import { useToastNotificationContext } from '../../hooks/global/alert/useToastNotification';
import LoadingComponent from '../common/loadingComponent';

const CONNECTION_LOST_EVENT: EventName[] = [
  'receivingAudioDropped',
  'signalingDropped',
  'sendingAudioFailed',
];

const VIDEO_FAIL_EVENT: EventName[] = [
  'videoInputFailed',
  'deviceLabelTriggerFailed',
];

function MeetingStatusChecker() {
  const intl = useIntl();
  const {
    meetingPage,
    setIsMeetingEnded,
    setMeetingPage,
    setEndMeetingCustomMessage,
  } = useMeetingContext();
  const meetingStatus = useMeetingStatus();
  const meetingEvent = useMeetingEvent();
  const meetingManager = useMeetingManager();
  const { createToastNotification } = useToastNotificationContext();

  useEffect(() => {
    if (!meetingEvent) {
      return;
    }

    if (CONNECTION_LOST_EVENT.includes(meetingEvent.name)) {
      setEndMeetingCustomMessage(
        intl.formatMessage({
          defaultMessage: 'Connection Lost',
        }),
      );
      meetingManager.leave();
    }

    if (VIDEO_FAIL_EVENT.includes(meetingEvent.name)) {
      createToastNotification(
        intl.formatMessage({
          defaultMessage: 'Video input failed',
        }),
        'error',
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meetingEvent, setEndMeetingCustomMessage, meetingManager, intl]);

  if (meetingStatus === MeetingStatus.Ended) {
    setIsMeetingEnded(true);
  }

  if (
    meetingStatus === MeetingStatus.Ended ||
    meetingStatus === MeetingStatus.Left
  ) {
    setMeetingPage(MeetingPage.VIDEO_CALL_END);
  }

  if (
    meetingStatus === MeetingStatus.Loading &&
    meetingPage === MeetingPage.VIDEO_CALL
  ) {
    return (
      <Backdrop sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
        <LoadingComponent />
      </Backdrop>
    );
  }

  if (meetingStatus === MeetingStatus.Succeeded) {
    setMeetingPage(MeetingPage.VIDEO_CALL);
  }

  return null;
}

export default MeetingStatusChecker;
